<template>
  <div style="padding: 20px">
    <div style="top: 10px; position: absolute; right: 10px" class="noprint">
      <el-link type="primary" @click="backMain">返回</el-link>
    </div>
    <div
      slot="header"
      class="clearfix"
      style="text-align: center; margin-top: 60px; font-size: 14px"
    >
      <span class="noprint">志愿填报</span>
      <span class="printHide" style="font-weight: 900; font-size: 25px"
        >{{ currentYear }}年玉树州高中阶段招生志愿表</span
      >
      <span class="printHide">打印时间:{{ getDate() }}</span>
      <div style="margin-top: 20px" v-if="!disabledFlag">
        <el-radio
          v-model="zhiyuanType"
          label="2"
          :disabled="disabledFlag"
          >高中志愿</el-radio
        >
        <el-radio
          v-model="zhiyuanType"
          label="1"
          :disabled="disabledFlag"
          >中职志愿</el-radio
        >
      </div>
      <div style="margin-top: 20px" v-if="!disabledFlag">
        普通高中与中职志愿只能填写一种,不能同时填写.
      </div>
      <div class="noprint zhiyuan-status-tip" v-if="getZhiyuanStatusText()">
        {{ getZhiyuanStatusText() }}
      </div>
    </div>

    <center style="margin-top: 20px" id="dayin">
      <table border="1" style="margin-bottom: 10px">
        <tr>
          <th>姓名</th>
          <th>性别</th>
          <th>准考证号</th>
          <th>身份证号</th>
          <th>总分</th>
          <th>考生类型</th>
          <th>体检结果</th>
          <th>毕业学校</th>
        </tr>
        <tr>
          <td>{{ studentInfo.name }}</td>
          <td>{{ studentData[0].sex }}</td>
          <td>{{ studentInfo.testNum }}</td>
          <td>{{ studentInfo.idCard }}</td>
          <td>{{ studentInfo.zongfen }}</td>
          <td>{{ studentData[0].languageType }}</td>
          <td>{{ studentData[0].sick }}</td>
          <td>{{ studentInfo.school }}</td>
        </tr>
      </table>

      <table
        border="1"
        v-if="zhiyuanType === '2'"
        class="gaozhong-volunteer-table"
      >
        <tr class="volunteer-table-header">
          <th>批次</th>
          <th></th>
          <th>学校</th>
        </tr>
        <template v-for="batch in gaozhongBatchCount">
          <template v-for="schoolCount in gaozhongSchoolCount">
            <tr
              v-if="
                isVolunteerSchoolVisible('gaozhong', batch, schoolCount)
              "
              :class="{
                'gaozhong-volunteer-group-alt': schoolCount % 2 === 0,
                'gaozhong-volunteer-group-start': schoolCount === 1,
                'gaozhong-batch-frame-start': schoolCount === 1,
                'gaozhong-batch-frame-end':
                  schoolCount === getVolunteerSchoolCount('gaozhong', batch)
              }"
            >
              <td
                class="gaozhong-batch-cell"
                :rowspan="getVolunteerSchoolCount('gaozhong', batch)"
                v-if="schoolCount === 1"
              >
                第{{ batch }}批次
              </td>
              <td>第{{ schoolCount }}志愿</td>
              <td class="gaozhong-school-cell">
                <select
                  v-model="zhiyuanForm['g' + batch + schoolCount]"
                  @change="gaozhongSchoolChange(batch, schoolCount)"
                  :disabled="
                    disabledFlag ||
                      !canSelectGaozhongSchool(batch, schoolCount)
                  "
                >
                  <option></option>
                  <option
                    v-for="item in getAvailableGaozhongSchools(
                      batch,
                      schoolCount
                    )"
                    :key="item.id"
                    :label="item.school"
                    :value="item.id"
                  ></option>
                </select>
              </td>
            </tr>
          </template>
        </template>
        <tr class="noprint">
          <td colspan="30000">
            <div>
              <!-- <input
                type="checkbox"
                v-model="gzCheckbox"
                :disabled="disabledFlag"
              />我已经填完志愿不再更改 -->
            </div>
            <div>
              <button @click="saveGaozhongDraft" v-if="!disabledFlag">
                保存草稿
              </button>
              <button @click="gaozhongClick" v-if="!disabledFlag">
                正式提交志愿
              </button>
            </div>
            <div>
              <button
                @click="downloadConfirmSheet"
                :disabled="!canDownloadConfirmSheet()"
                :title="getDownloadConfirmTitle()"
              >
                下载志愿确认单
              </button>
            </div>
          </td>
        </tr>
      </table>

      <table
        border="1"
        v-if="zhiyuanType === '1'"
        class="zhongzhi-volunteer-table"
      >
        <tr class="volunteer-table-header">
          <th>批次</th>
          <th colspan="2">学校</th>
          <th colspan="2">专业志愿</th>
        </tr>
        <template v-for="batch in zhongzhiBatchCount">
          <template v-for="schoolCount in zhongzhiSchoolCount">
            <template v-for="zhuanyeCount in zhuanye">
              <tr
                v-if="
                  isVolunteerSchoolVisible('zhongzhi', batch, schoolCount)
                "
                :class="{
                  'zhongzhi-volunteer-group-alt': schoolCount % 2 === 0,
                  'zhongzhi-volunteer-group-start': zhuanyeCount === 1,
                  'zhongzhi-batch-frame-start':
                    schoolCount === 1 && zhuanyeCount === 1,
                  'zhongzhi-batch-frame-end':
                    schoolCount ===
                      getVolunteerSchoolCount('zhongzhi', batch) &&
                    zhuanyeCount === zhuanye
                }"
              >
                <td
                  class="zhongzhi-batch-cell"
                  :rowspan="getVolunteerSchoolCount('zhongzhi', batch) * zhuanye"
                  v-if="schoolCount === 1 && zhuanyeCount === 1"
                >
                  第{{ batch }}批次
                </td>
                <td
                  :class="{
                    'zhongzhi-batch-last-school-cell':
                      schoolCount ===
                      getVolunteerSchoolCount('zhongzhi', batch)
                  }"
                  :rowspan="zhuanye"
                  v-if="zhuanyeCount === 1"
                >
                  第{{ schoolCount }}志愿
                </td>
                <td
                  :class="{
                    'zhongzhi-batch-last-school-cell':
                      schoolCount ===
                      getVolunteerSchoolCount('zhongzhi', batch)
                  }"
                  :rowspan="zhuanye"
                  v-if="zhuanyeCount === 1"
                >
                  <select
                    v-model="zzSchoolNameForm['z' + batch + schoolCount]"
                    @change="zzSchoolChange(batch, schoolCount, $event)"
                    :disabled="
                      disabledFlag ||
                        !canSelectZhongzhiSchool(batch, schoolCount)
                    "
                  >
                    <option></option>
                    <option
                      v-for="item in getAvailableZhongzhiSchools(
                        batch,
                        schoolCount
                      )"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></option>
                  </select>
                </td>
                <td class="zhongzhi-major-label">
                  专业志愿{{ zhuanyeCount }}
                </td>
                <td class="zhongzhi-major-select-cell">
                  <select
                    v-model="
                      zzZhiyuanForm['z' + batch + schoolCount + zhuanyeCount]
                    "
                    @change="
                      zzMajorChange(batch, schoolCount, zhuanyeCount)
                    "
                    :disabled="
                      disabledFlag ||
                        !canSelectZhongzhiMajor(
                          batch,
                          schoolCount,
                          zhuanyeCount
                        )
                    "
                  >
                    <option></option>
                    <option
                      v-for="item in getAvailableZhongzhiMajors(
                        batch,
                        schoolCount,
                        zhuanyeCount
                      )"
                      :key="item.id"
                      :label="item.major"
                      :value="item.id"
                    ></option>
                  </select>
                </td>
              </tr>
            </template>
          </template>
        </template>

        <tr class="noprint">
          <td colspan="5">
            <div>
              <!-- <input
                type="checkbox"
                v-model="zzCheckbox"
                :disabled="disabledFlag"
              />我已经填完志愿不再更改 -->
              <input
                type="checkbox"
                v-model="tiaoji"
                :disabled="disabledFlag"
              />服从调剂
            </div>
            <div>
              <button @click="saveZhongzhiDraft" v-if="!disabledFlag">
                保存草稿
              </button>
              <button @click="zhongzhiClick" v-if="!disabledFlag">
                正式提交志愿
              </button>
            </div>
            <div>
              <button
                @click="downloadConfirmSheet"
                :disabled="!canDownloadConfirmSheet()"
                :title="getDownloadConfirmTitle()"
              >
                下载志愿确认单
              </button>
            </div>
          </td>
        </tr>
      </table>
      <div class="printHide" style="float: left">
        <span style="margin-right: 50px"
          >是否服从调剂(仅限中职):{{ tiaoji === true ? '是' : '否' }}</span
        >
        <span>以上信息经本人审核,确认无误.</span
        ><span style="margin-left: 20px">家长:</span
        ><span style="margin-left: 150px">学生:</span>
      </div>
    </center>
  </div>
</template>
<script>
import { getStudentInfo, saveAdmit } from '@/common/apis/main.js'
export default {
  data() {
    return {
      studentInfo: {},
      zhiyuanType: '',
      zhongzhiBatchCount: 0,
      zhongzhiSchoolCount: 0,
      zhuanye: 0,
      gaozhongBatchCount: 0,
      gaozhongSchoolCount: 0,
      zhiyuanFlag: '',
      zhiyuanSubmit: '',
      zhiyuanForm: {},
      zzZhiyuanForm: {},
      zzSchoolNameForm: {},
      //高中1-5批次学校集合
      g1: [],
      g2: [],
      g3: [],
      g4: [],
      g5: [],
      //中职1-5批次学校集合
      z1: [],
      z2: [],
      z3: [],
      z4: [],
      z5: [],
      gNames: [],
      zNames: [],
      zName1: [],
      zName2: [],
      zName3: [],
      zName4: [],
      zName5: [],
      gArrs: [],
      zArrs: [],
      zOptionArrs: {},
      gzCheckbox: false,
      zzCheckbox: false,
      disabledFlag: false,
      studentInfoLoaded: false,
      hasSavedDraft: false,
      studentData: [{}],
      printObjAll: {
        id: 'dayin',
        popTitle: '123'
      },
      currentYear: '',
      tiaoji: false
    }
  },
  created() {
    const nowTime = new Date()
    let year = nowTime.getFullYear() + ''
    this.currentYear = year
    this.getStudentInfo()
  },
  methods: {
    getVolunteerSchoolCount(type, batch) {
      if (this.currentYear === '2026') {
        const rules =
          type === 'gaozhong'
            ? { 1: 3, 2: 3, 3: 6 }
            : { 1: 1, 2: 3, 3: 2, 4: 1 }
        return rules[batch] || 0
      }
      return type === 'gaozhong'
        ? this.gaozhongSchoolCount
        : this.zhongzhiSchoolCount
    },
    isVolunteerSchoolVisible(type, batch, schoolCount) {
      return schoolCount <= this.getVolunteerSchoolCount(type, batch)
    },
    clearHiddenVolunteerSlots() {
      if (!this.zhiyuanForm) {
        this.zhiyuanForm = {}
      }
      if (!this.zzSchoolNameForm) {
        this.zzSchoolNameForm = {}
      }
      if (!this.zzZhiyuanForm) {
        this.zzZhiyuanForm = {}
      }

      for (let batch = 1; batch <= this.gaozhongBatchCount; batch++) {
        const schoolCount = this.getVolunteerSchoolCount('gaozhong', batch)
        for (
          let index = schoolCount + 1;
          index <= this.gaozhongSchoolCount;
          index++
        ) {
          this.$set(this.zhiyuanForm, 'g' + batch + index, '')
        }
      }

      for (let batch = 1; batch <= this.zhongzhiBatchCount; batch++) {
        const schoolCount = this.getVolunteerSchoolCount('zhongzhi', batch)
        for (
          let index = schoolCount + 1;
          index <= this.zhongzhiSchoolCount;
          index++
        ) {
          const schoolKey = 'z' + batch + index
          this.$set(this.zzSchoolNameForm, schoolKey, '')
          this.$set(this.zOptionArrs, schoolKey, [])
          for (let majorIndex = 1; majorIndex <= this.zhuanye; majorIndex++) {
            this.$set(this.zzZhiyuanForm, schoolKey + majorIndex, '')
          }
        }
      }
    },
    getStudentInfo() {
      getStudentInfo().then((res) => {
        if (res.data.code === '0000') {
          this.studentInfo = res.data.data.studentInfo
          this.studentData = res.data.data.info
          this.zhongzhiBatchCount = parseInt(res.data.data.zhongzhiBatchCount)
          this.zhongzhiSchoolCount = parseInt(res.data.data.zhongzhiSchoolCount)
          this.gaozhongBatchCount = parseInt(res.data.data.gaozhongBatchCount)
          this.gaozhongSchoolCount = parseInt(res.data.data.gaozhongSchoolCount)
          this.zhuanye = parseInt(res.data.data.zhuanye)
          for (let i = 1; i <= this.gaozhongBatchCount; i++) {
            for (let j = 1; j <= this.gaozhongSchoolCount; j++) {
              this.$set(this.zhiyuanForm, 'g' + i + j, '')
            }
          }

          for (let i = 1; i <= this.zhongzhiBatchCount; i++) {
            for (let j = 1; j <= this.zhongzhiSchoolCount; j++) {
              this.$set(this.zzSchoolNameForm, 'z' + i + j, '')
              this.$set(this.zOptionArrs, 'z' + i + j, [])
              for (let m = 1; m <= this.zhuanye; m++) {
                this.$set(this.zzZhiyuanForm, 'z' + i + j + m, '')
              }
            }
          }

          let zhiyuanObj = res.data.data.zhiyuan

          this.zhiyuanFlag = res.data.data.zhiyuanFlag
          this.zhiyuanSubmit = res.data.data.zhiyuanSubmit
          this.hasSavedDraft =
            !this.isZhiyuanSubmitted() &&
            this.hasSelectedZhiyuan(res.data.data.selectedZhiyuan)
          this.syncZhiyuanEditableStatus()
          if (this.isZhiyuanSubmitted()) {
            this.gzCheckbox = true
            this.zzCheckbox = true
          }
          this.gArrs = res.data.data.zhiyuan.gArrs

          this.zArrs = zhiyuanObj.zArrs
          this.z1 = zhiyuanObj.z1
          this.z2 = zhiyuanObj.z2
          this.z3 = zhiyuanObj.z3
          this.z4 = zhiyuanObj.z4
          this.z5 = zhiyuanObj.z5

          this.zName1 = zhiyuanObj.zName1
          this.zName2 = zhiyuanObj.zName2
          this.zName3 = zhiyuanObj.zName3
          this.zName4 = zhiyuanObj.zName4
          this.zName5 = zhiyuanObj.zName5

          this.zNames = zhiyuanObj.zNames

          if (this.studentInfo.gzFlag === '1') {
            this.zhiyuanType = '2'
            this.zhiyuanForm = res.data.data.selectedZhiyuan
            delete this.zhiyuanForm.zzName
          }

          if (this.studentInfo.zzFlag === '1') {
            this.zhiyuanType = '1'
            this.zzSchoolNameForm = res.data.data.selectedZhiyuan.zzName
            this.zzZhiyuanForm = res.data.data.selectedZhiyuan
            delete this.zzZhiyuanForm.zzName
            //构造下拉框
            if (this.zzSchoolNameForm) {//这个if是因为1月修时报错加上的,后面如果有问题,可删掉
              for (var key in this.zzSchoolNameForm) {
                let tempBatch = key.substring(1, 2)
                let tempSchoolIndex = key.substring(2, 3)
                let tempSchoolValue = this.zzSchoolNameForm[key]
                this.zzSchoolChangeCopy(
                  tempBatch,
                  tempSchoolIndex,
                  tempSchoolValue
                )
              }
            }
          }
          this.clearHiddenVolunteerSlots()
        } else if (res.data.code === '0001') {
          this.$message.error(res.data.message)
          return false
        }
        this.tiaoji = this.studentInfo.tiaoji
        if (this.tiaoji === '1') {
          this.tiaoji = true
        }
        this.studentInfoLoaded = true
      })
    },
    saveGaozhongDraft() {
      if (!this.canOperateZhiyuan()) {
        return false
      }
      this.clearHiddenVolunteerSlots()
      if (!this.validateGaozhongZhiyuan()) {
        return false
      }
      this.showZhiyuanConfirm('draft', 'gaozhong')
        .then(() => {
          this.zhiyuanForm.action = 'gaozhong'
          this.zhiyuanForm.check = false
          saveAdmit(this.zhiyuanForm).then((res) => {
            if (res.data.code === '0000') {
              this.hasSavedDraft = true
              this.$message.success('保存草稿成功')
            } else if (res.data.code === '0001') {
              this.$message.error(res.data.message)
              return false
            }
          })
        })
        .catch(() => {
          return false
        })
    },
    gaozhongClick() {
      //   this.zhiyuanForm.g11 = '240194751846940672'
      //   console.log(this.zhiyuanForm)
      if (!this.canOperateZhiyuan()) {
        return false
      }
      this.clearHiddenVolunteerSlots()
      if (!this.validateGaozhongZhiyuan()) {
        return false
      }
      this.showZhiyuanConfirm('submit', 'gaozhong')
        .then(() => {
          this.zhiyuanForm.action = 'gaozhong'
          this.zhiyuanForm.check = true
          saveAdmit(this.zhiyuanForm).then((res) => {
            if (res.data.code === '0000') {
              this.zhiyuanSubmit = '1'
              this.hasSavedDraft = false
              this.syncZhiyuanEditableStatus()
              this.$message.success(res.data.message)
            } else if (res.data.code === '0001') {
              this.$message.error(res.data.message)
              return false
            }
          })
        })
        .catch(() => {
          return false
        })
    },
    saveZhongzhiDraft() {
      if (!this.canOperateZhiyuan()) {
        return false
      }
      this.clearHiddenVolunteerSlots()
      if (!this.validateZhongzhiZhiyuan()) {
        return false
      }
      this.showZhiyuanConfirm('draft', 'zhongzhi')
        .then(() => {
          this.zzZhiyuanForm.action = 'zhongzhi'
          this.zzZhiyuanForm.check = false
          this.zzZhiyuanForm.zzSchoolNameForm = this.zzSchoolNameForm
          if (this.tiaoji === true) {
            this.zzZhiyuanForm.tiaoji = '1'
          } else {
            this.zzZhiyuanForm.tiaoji = ''
          }
          saveAdmit(this.zzZhiyuanForm).then((res) => {
            if (res.data.code === '0000') {
              this.hasSavedDraft = true
              this.$message.success('保存草稿成功')
            } else if (res.data.code === '0001') {
              this.$message.error(res.data.message)
              return false
            }
          })
        })
        .catch(() => {
          return false
        })
    },
    zhongzhiClick() {
      // this.zzSchoolNameForm.z11 = "四川德阳通用电子科技学校"
      //   console.log(this.zzSchoolNameForm)
      //   console.log(this.zzZhiyuanForm)
      //   console.log(this.zzZhiyuanForm)
      if (!this.canOperateZhiyuan()) {
        return false
      }
      this.clearHiddenVolunteerSlots()
      if (!this.validateZhongzhiZhiyuan()) {
        return false
      }
      this.showZhiyuanConfirm('submit', 'zhongzhi')
        .then(() => {
          this.zzZhiyuanForm.action = 'zhongzhi'
          this.zzZhiyuanForm.check = true
          this.zzZhiyuanForm.zzSchoolNameForm = this.zzSchoolNameForm
          if (this.tiaoji === true) {
            this.zzZhiyuanForm.tiaoji = '1'
          } else {
            this.zzZhiyuanForm.tiaoji = ''
          }
          saveAdmit(this.zzZhiyuanForm).then((res) => {
            if (res.data.code === '0000') {
              this.zhiyuanSubmit = '1'
              this.hasSavedDraft = false
              this.syncZhiyuanEditableStatus()
              this.$message.success(res.data.message)
            } else if (res.data.code === '0001') {
              this.$message.error(res.data.message)
              return false
            }
          })
        })
        .catch(() => {
          return false
        })
    },
    getAvailableGaozhongSchools(batch, schoolCount) {
      const list = this.gArrs[batch - 1] || []
      const currentValue = this.zhiyuanForm['g' + batch + schoolCount]
      const selectedSchools = Object.create(null)
      for (let i = 1; i <= this.gaozhongSchoolCount; i++) {
        if (i === schoolCount) {
          continue
        }
        const value = this.zhiyuanForm['g' + batch + i]
        if (this.hasZhiyuanValue(value)) {
          selectedSchools[
            this.getGaozhongSchoolOptionKey(batch, value)
          ] = true
        }
      }
      return list.filter((item) => {
        return (
          this.isSameZhiyuanValue(item.id, currentValue) ||
          !selectedSchools[this.getZhiyuanOptionKey(item.school || item.id)]
        )
      })
    },
    getAvailableZhongzhiSchools(batch, schoolCount) {
      const list = this.zNames[batch - 1] || []
      const currentValue = this.zzSchoolNameForm['z' + batch + schoolCount]
      const selectedSchools = Object.create(null)
      for (let i = 1; i <= this.zhongzhiSchoolCount; i++) {
        if (i === schoolCount) {
          continue
        }
        const value = this.zzSchoolNameForm['z' + batch + i]
        if (this.hasZhiyuanValue(value)) {
          selectedSchools[this.getZhiyuanOptionKey(value)] = true
        }
      }
      return list.filter((item) => {
        return (
          this.isSameZhiyuanValue(item, currentValue) ||
          !selectedSchools[this.getZhiyuanOptionKey(item)]
        )
      })
    },
    getAvailableZhongzhiMajors(batch, schoolCount, majorIndex) {
      const schoolKey = 'z' + batch + schoolCount
      const list = this.zOptionArrs[schoolKey] || []
      const currentValue = this.zzZhiyuanForm[schoolKey + majorIndex]
      const selectedMajors = Object.create(null)
      for (let i = 1; i <= this.zhuanye; i++) {
        if (i === majorIndex) {
          continue
        }
        const value = this.zzZhiyuanForm[schoolKey + i]
        if (this.hasZhiyuanValue(value)) {
          selectedMajors[this.getZhiyuanOptionKey(value)] = true
        }
      }
      return list.filter((item) => {
        return (
          this.isSameZhiyuanValue(item.id, currentValue) ||
          !selectedMajors[this.getZhiyuanOptionKey(item.id)]
        )
      })
    },
    canSelectGaozhongSchool(batch, schoolCount) {
      const currentValue = this.zhiyuanForm['g' + batch + schoolCount]
      return (
        this.hasZhiyuanValue(currentValue) ||
        this.arePreviousGaozhongSchoolsFilled(batch, schoolCount)
      )
    },
    canSelectZhongzhiSchool(batch, schoolCount) {
      const currentValue = this.zzSchoolNameForm['z' + batch + schoolCount]
      return (
        this.hasZhiyuanValue(currentValue) ||
        this.arePreviousZhongzhiSchoolsFilled(batch, schoolCount)
      )
    },
    canSelectZhongzhiMajor(batch, schoolCount, majorIndex) {
      const schoolKey = 'z' + batch + schoolCount
      const currentValue = this.zzZhiyuanForm[schoolKey + majorIndex]
      if (this.hasZhiyuanValue(currentValue)) {
        return true
      }
      return (
        this.hasZhiyuanValue(this.zzSchoolNameForm[schoolKey]) &&
        this.arePreviousZhongzhiMajorsFilled(
          batch,
          schoolCount,
          majorIndex
        )
      )
    },
    arePreviousGaozhongSchoolsFilled(batch, schoolCount) {
      for (let i = 1; i < schoolCount; i++) {
        if (!this.hasZhiyuanValue(this.zhiyuanForm['g' + batch + i])) {
          return false
        }
      }
      return true
    },
    arePreviousZhongzhiSchoolsFilled(batch, schoolCount) {
      for (let i = 1; i < schoolCount; i++) {
        if (!this.hasZhiyuanValue(this.zzSchoolNameForm['z' + batch + i])) {
          return false
        }
      }
      return true
    },
    arePreviousZhongzhiMajorsFilled(batch, schoolCount, majorIndex) {
      const schoolKey = 'z' + batch + schoolCount
      for (let i = 1; i < majorIndex; i++) {
        if (!this.hasZhiyuanValue(this.zzZhiyuanForm[schoolKey + i])) {
          return false
        }
      }
      return true
    },
    getGaozhongSchoolOptionKey(batch, schemeId) {
      const list = this.gArrs[batch - 1] || []
      for (let i = 0; i < list.length; i++) {
        if (this.isSameZhiyuanValue(list[i].id, schemeId)) {
          return this.getZhiyuanOptionKey(list[i].school || list[i].id)
        }
      }
      return this.getZhiyuanOptionKey(schemeId)
    },
    getZhiyuanOptionKey(value) {
      return this.hasZhiyuanValue(value) ? String(value).trim() : ''
    },
    isSameZhiyuanValue(left, right) {
      return (
        this.hasZhiyuanValue(left) &&
        this.hasZhiyuanValue(right) &&
        this.getZhiyuanOptionKey(left) === this.getZhiyuanOptionKey(right)
      )
    },
    hasDuplicateGaozhongSchool(batch, schoolCount, value) {
      const currentSchool = this.getGaozhongSchoolOptionKey(batch, value)
      for (let i = 1; i <= this.gaozhongSchoolCount; i++) {
        if (i === schoolCount) {
          continue
        }
        const otherValue = this.zhiyuanForm['g' + batch + i]
        if (
          this.hasZhiyuanValue(otherValue) &&
          this.getGaozhongSchoolOptionKey(batch, otherValue) === currentSchool
        ) {
          return true
        }
      }
      return false
    },
    hasDuplicateZhongzhiSchool(batch, schoolCount, value) {
      const currentSchool = this.getZhiyuanOptionKey(value)
      for (let i = 1; i <= this.zhongzhiSchoolCount; i++) {
        if (i === schoolCount) {
          continue
        }
        const otherValue = this.zzSchoolNameForm['z' + batch + i]
        if (
          this.hasZhiyuanValue(otherValue) &&
          this.getZhiyuanOptionKey(otherValue) === currentSchool
        ) {
          return true
        }
      }
      return false
    },
    hasDuplicateZhongzhiMajor(batch, schoolCount, majorIndex, value) {
      const schoolKey = 'z' + batch + schoolCount
      for (let i = 1; i <= this.zhuanye; i++) {
        if (i === majorIndex) {
          continue
        }
        if (this.isSameZhiyuanValue(this.zzZhiyuanForm[schoolKey + i], value)) {
          return true
        }
      }
      return false
    },
    gaozhongSchoolChange(batch, schoolCount) {
      const key = 'g' + batch + schoolCount
      const value = this.zhiyuanForm[key]
      if (
        this.hasZhiyuanValue(value) &&
        !this.arePreviousGaozhongSchoolsFilled(batch, schoolCount)
      ) {
        this.$set(this.zhiyuanForm, key, '')
        this.clearFollowingGaozhongSchools(batch, schoolCount)
        this.$message.error(
          '请先按顺序填写第' + batch + '批次前序学校志愿'
        )
        return
      }
      if (
        this.hasZhiyuanValue(value) &&
        this.hasDuplicateGaozhongSchool(batch, schoolCount, value)
      ) {
        this.$set(this.zhiyuanForm, key, '')
        this.clearFollowingGaozhongSchools(batch, schoolCount)
        this.$message.error('第' + batch + '批次学校志愿不能重复')
        return
      }
      if (
        !this.hasZhiyuanValue(value) &&
        this.clearFollowingGaozhongSchools(batch, schoolCount)
      ) {
        this.$message.warning('已清空本批次后续学校志愿，请按顺序填写')
      }
    },
    clearFollowingGaozhongSchools(batch, schoolCount) {
      let cleared = false
      for (let i = schoolCount + 1; i <= this.gaozhongSchoolCount; i++) {
        const key = 'g' + batch + i
        if (this.hasZhiyuanValue(this.zhiyuanForm[key])) {
          cleared = true
        }
        this.$set(this.zhiyuanForm, key, '')
      }
      return cleared
    },
    zzMajorChange(batch, schoolCount, majorIndex) {
      const schoolKey = 'z' + batch + schoolCount
      const key = schoolKey + majorIndex
      const value = this.zzZhiyuanForm[key]
      if (
        this.hasZhiyuanValue(value) &&
        !this.arePreviousZhongzhiMajorsFilled(
          batch,
          schoolCount,
          majorIndex
        )
      ) {
        this.$set(this.zzZhiyuanForm, key, '')
        this.clearFollowingZhongzhiMajors(batch, schoolCount, majorIndex)
        this.$message.error(
          '请先按顺序填写第' +
            batch +
            '批次第' +
            schoolCount +
            '志愿的前序专业志愿'
        )
        return
      }
      if (
        this.hasZhiyuanValue(value) &&
        this.hasDuplicateZhongzhiMajor(
          batch,
          schoolCount,
          majorIndex,
          value
        )
      ) {
        this.$set(this.zzZhiyuanForm, key, '')
        this.clearFollowingZhongzhiMajors(batch, schoolCount, majorIndex)
        this.$message.error(
          '第' +
            batch +
            '批次第' +
            schoolCount +
            '志愿的专业志愿不能重复'
        )
        return
      }
      if (
        !this.hasZhiyuanValue(value) &&
        this.clearFollowingZhongzhiMajors(batch, schoolCount, majorIndex)
      ) {
        this.$message.warning('已清空该学校后续专业志愿，请按顺序填写')
      }
    },
    clearFollowingZhongzhiMajors(batch, schoolCount, majorIndex) {
      let cleared = false
      const schoolKey = 'z' + batch + schoolCount
      for (let i = majorIndex + 1; i <= this.zhuanye; i++) {
        const key = schoolKey + i
        if (this.hasZhiyuanValue(this.zzZhiyuanForm[key])) {
          cleared = true
        }
        this.$set(this.zzZhiyuanForm, key, '')
      }
      return cleared
    },
    validateGaozhongZhiyuan() {
      let hasSchool = false
      for (let i = 1; i <= this.gaozhongBatchCount; i++) {
        const selectedSchools = Object.create(null)
        let hasEmptySchool = false
        for (let j = 1; j <= this.gaozhongSchoolCount; j++) {
          const value = this.zhiyuanForm['g' + i + j]
          if (!this.hasZhiyuanValue(value)) {
            hasEmptySchool = true
            continue
          }
          hasSchool = true
          if (hasEmptySchool) {
            this.$message.error(
              '第' + i + '批次学校志愿必须从第1志愿开始连续填写'
            )
            return false
          }
          const schoolKey = this.getGaozhongSchoolOptionKey(i, value)
          if (selectedSchools[schoolKey]) {
            this.$message.error('第' + i + '批次学校志愿不能重复')
            return false
          }
          selectedSchools[schoolKey] = true
        }
      }
      if (hasSchool) {
        return true
      }
      this.$message.error('请至少选择一个高中学校后再提交')
      return false
    },
    validateZhongzhiZhiyuan() {
      let hasSchool = false
      let hasMajor = false
      let hasEffectiveZhiyuan = false
      const schoolForm = this.zzSchoolNameForm || {}
      const majorForm = this.zzZhiyuanForm || {}
      for (let i = 1; i <= this.zhongzhiBatchCount; i++) {
        const selectedSchools = Object.create(null)
        let hasEmptySchool = false
        for (let j = 1; j <= this.zhongzhiSchoolCount; j++) {
          const schoolKey = 'z' + i + j
          const currentHasSchool = this.hasZhiyuanValue(schoolForm[schoolKey])
          let currentHasMajor = false
          if (currentHasSchool) {
            hasSchool = true
            if (hasEmptySchool) {
              this.$message.error(
                '第' + i + '批次学校志愿必须从第1志愿开始连续填写'
              )
              return false
            }
            const schoolNameKey = this.getZhiyuanOptionKey(
              schoolForm[schoolKey]
            )
            if (selectedSchools[schoolNameKey]) {
              this.$message.error(
                '中职学校志愿不能重复，请检查第' +
                  i +
                  '批次第' +
                  j +
                  '志愿'
              )
              return false
            }
            selectedSchools[schoolNameKey] = true
          } else {
            hasEmptySchool = true
          }
          const selectedMajors = Object.create(null)
          let hasEmptyMajor = false
          for (let m = 1; m <= this.zhuanye; m++) {
            const majorValue = majorForm[schoolKey + m]
            if (this.hasZhiyuanValue(majorValue)) {
              if (!currentHasSchool) {
                this.$message.error(
                  '请先选择第' + i + '批次第' + j + '志愿的中职学校'
                )
                return false
              }
              if (hasEmptyMajor) {
                this.$message.error(
                  '第' +
                    i +
                    '批次第' +
                    j +
                    '志愿的专业志愿必须从专业志愿1开始连续填写'
                )
                return false
              }
              const majorKey = String(majorValue).trim()
              if (selectedMajors[majorKey]) {
                this.$message.error(
                  '同一学校的专业志愿不能重复，请检查第' +
                    i +
                    '批次第' +
                    j +
                    '志愿专业志愿' +
                    m
                )
                return false
              }
              selectedMajors[majorKey] = true
              currentHasMajor = true
              hasMajor = true
            } else {
              hasEmptyMajor = true
            }
          }
          if (currentHasSchool && !currentHasMajor) {
            this.$message.error(
              '第' +
                i +
                '批次第' +
                j +
                '志愿已选择学校，请至少选择一个专业志愿后再保存或正式提交'
            )
            return false
          }
          if (currentHasSchool && currentHasMajor) {
            hasEffectiveZhiyuan = true
          }
        }
      }
      if (hasEffectiveZhiyuan) {
        return true
      }
      if (this.tiaoji === true && !hasSchool && !hasMajor) {
        this.$message.error('仅勾选服从调剂不属于有效志愿，请选择学校并至少选择一个专业')
        return false
      }
      if (hasSchool && !hasMajor) {
        this.$message.error('中职志愿必须选择学校并至少选择一个专业')
        return false
      }
      if (!hasSchool && hasMajor) {
        this.$message.error('中职志愿必须先选择学校，并至少选择一个专业')
        return false
      }
      this.$message.error('请至少选择一个中职学校并选择至少一个专业后再提交')
      return false
    },
    showZhiyuanConfirm(saveType, formType) {
      const isSubmit = saveType === 'submit'
      const actionLabel = isSubmit ? '正式提交志愿' : '保存草稿'
      const formLabel = formType === 'gaozhong' ? '高中志愿' : '中职志愿'
      const details =
        formType === 'gaozhong'
          ? this.getGaozhongZhiyuanDetails()
          : this.getZhongzhiZhiyuanDetails()
      const message = this.buildZhiyuanConfirmHtml(
        actionLabel,
        formLabel,
        formType,
        details,
        saveType
      )
      return this.$confirm(
        message,
        isSubmit ? '请确认正式提交志愿' : '请确认保存草稿',
        {
        dangerouslyUseHTMLString: true,
        confirmButtonText: isSubmit ? '确认正式提交志愿' : '确认保存草稿',
        cancelButtonText: '返回修改',
        customClass: 'zhiyuan-confirm-box',
        closeOnClickModal: false,
        type: isSubmit ? 'warning' : 'info'
        }
      )
    },
    buildZhiyuanConfirmHtml(actionLabel, formLabel, formType, details, saveType) {
      const detailHtml = details.length
        ? this.buildZhiyuanDetailHtml(formType, details)
        : '<div class="zy-empty-detail">未检测到有效志愿</div>'
      const tiaojiText =
        formType === 'zhongzhi' ? (this.tiaoji === true ? '是' : '否') : '不适用'
      const isSubmit = saveType === 'submit'
      const introText = isSubmit
        ? '确认提交后志愿将作为最终志愿，请务必仔细核对。'
        : '本次仅保存草稿，后续仍可修改，未确认提交前不作为最终志愿。'
      const alertClass = isSubmit ? 'zy-confirm-alert danger' : 'zy-confirm-alert warning'
      return (
        '<div class="zy-confirm-content">' +
        '<div class="zy-confirm-intro">' +
        this.escapeHtml(introText) +
        '</div>' +
        '<div class="zy-summary-grid">' +
        '<div class="zy-summary-card"><span>操作类型</span><strong>' +
        this.escapeHtml(actionLabel) +
        '</strong></div>' +
        '<div class="zy-summary-card"><span>志愿类型</span><strong>' +
        this.escapeHtml(formLabel) +
        '</strong></div>' +
        '<div class="zy-summary-card"><span>有效志愿数量</span><strong>' +
        details.length +
        '</strong></div>' +
        '<div class="zy-summary-card"><span>服从调剂</span><strong>' +
        this.escapeHtml(tiaojiText) +
        '</strong></div>' +
        '</div>' +
        '<div class="zy-detail-title">有效志愿明细</div>' +
        detailHtml +
        '<div class="' +
        alertClass +
        '">' +
        '<strong>温馨提示：</strong>' +
        this.escapeHtml(introText) +
        '</div>' +
        '</div>'
      )
    },
    buildZhiyuanDetailHtml(formType, details) {
      let html =
        '<table class="zy-detail-table"><thead><tr><th>批次</th><th>志愿</th><th>学校</th><th>专业志愿</th></tr></thead><tbody>'
      details.forEach((item) => {
        if (formType === 'gaozhong') {
          html +=
            '<tr><td>第' +
            item.batch +
            '批次</td><td>第' +
            item.schoolIndex +
            '志愿</td><td>' +
            this.escapeHtml(item.schoolName) +
            '</td><td>-</td></tr>'
        } else {
          const majors = item.majors
            .map((major) => {
              return (
                '<div>专业志愿' +
                major.majorIndex +
                '：' +
                this.escapeHtml(major.majorName) +
                '</div>'
              )
            })
            .join('')
          html +=
            '<tr><td>第' +
            item.batch +
            '批次</td><td>第' +
            item.schoolIndex +
            '志愿</td><td>' +
            this.escapeHtml(item.schoolName) +
            '</td><td>' +
            majors +
            '</td></tr>'
        }
      })
      html += '</tbody></table>'
      return html
    },
    getGaozhongZhiyuanDetails() {
      const details = []
      const form = this.zhiyuanForm || {}
      for (let i = 1; i <= this.gaozhongBatchCount; i++) {
        for (let j = 1; j <= this.gaozhongSchoolCount; j++) {
          const key = 'g' + i + j
          const schemeId = form[key]
          if (this.hasZhiyuanValue(schemeId)) {
            details.push({
              batch: i,
              schoolIndex: j,
              schoolName: this.getGaozhongSchoolName(i, schemeId)
            })
          }
        }
      }
      return details
    },
    getZhongzhiZhiyuanDetails() {
      const details = []
      const schoolForm = this.zzSchoolNameForm || {}
      const majorForm = this.zzZhiyuanForm || {}
      for (let i = 1; i <= this.zhongzhiBatchCount; i++) {
        for (let j = 1; j <= this.zhongzhiSchoolCount; j++) {
          const schoolKey = 'z' + i + j
          const schoolName = schoolForm[schoolKey]
          const majors = []
          for (let m = 1; m <= this.zhuanye; m++) {
            const majorId = majorForm[schoolKey + m]
            if (this.hasZhiyuanValue(majorId)) {
              majors.push({
                majorIndex: m,
                majorName: this.getZhongzhiMajorName(schoolKey, majorId)
              })
            }
          }
          if (this.hasZhiyuanValue(schoolName) && majors.length > 0) {
            details.push({
              batch: i,
              schoolIndex: j,
              schoolName: schoolName,
              majors: majors
            })
          }
        }
      }
      return details
    },
    getGaozhongSchoolName(batch, schemeId) {
      const list = this.gArrs[batch - 1] || []
      for (let i = 0; i < list.length; i++) {
        if (String(list[i].id) === String(schemeId)) {
          return list[i].school || schemeId
        }
      }
      return schemeId
    },
    getZhongzhiMajorName(schoolKey, schemeId) {
      let list = this.zOptionArrs[schoolKey] || []
      for (let i = 0; i < list.length; i++) {
        if (String(list[i].id) === String(schemeId)) {
          return list[i].major || schemeId
        }
      }
      for (let i = 0; i < this.zArrs.length; i++) {
        list = this.zArrs[i] || []
        for (let j = 0; j < list.length; j++) {
          if (String(list[j].id) === String(schemeId)) {
            return list[j].major || schemeId
          }
        }
      }
      return schemeId
    },
    downloadConfirmSheet() {
      if (!this.canDownloadConfirmSheet()) {
        this.$message.error('正式提交后才能下载志愿确认单')
        return false
      }
      getStudentInfo().then(async (res) => {
        if (res.data.code === '0000') {
          const data = res.data.data || {}
          if (String(data.zhiyuanSubmit) !== '1') {
            this.$message.error('正式提交后才能下载志愿确认单')
            return false
          }
          const sheetData = this.buildConfirmSheetData(data)
          if (!sheetData.details.length) {
            this.$message.error('未读取到正式志愿数据，无法下载确认单')
            return false
          }
          try {
            await this.downloadPdfFile(sheetData, this.buildConfirmSheetFileName(sheetData))
          } catch (e) {
            this.$message.error('生成PDF失败，请重新下载')
          }
        } else if (res.data.code === '0001') {
          this.$message.error(res.data.message)
          return false
        }
      })
    },
    canDownloadConfirmSheet() {
      return this.studentInfoLoaded && this.isZhiyuanSubmitted()
    },
    getDownloadConfirmTitle() {
      return this.canDownloadConfirmSheet()
        ? '下载志愿确认单'
        : '正式提交后才能下载志愿确认单'
    },
    buildConfirmSheetData(data) {
      const studentInfo = data.studentInfo || {}
      const infoList = data.info || []
      const info = infoList[0] || {}
      const selected = data.selectedZhiyuan || {}
      const zhiyuan = data.zhiyuan || {}
      const formType = studentInfo.gzFlag === '1' ? 'gaozhong' : 'zhongzhi'
      const generatedAt = new Date()
      const details =
        formType === 'gaozhong'
          ? this.getGaozhongConfirmDetails(selected, zhiyuan.gArrs || [])
          : this.getZhongzhiConfirmDetails(
              selected,
              selected.zzName || {},
              zhiyuan.zArrs || []
            )
      return {
        formType: formType,
        formLabel: formType === 'gaozhong' ? '高中志愿' : '中职志愿',
        studentInfo: studentInfo,
        info: info,
        tiaoji: studentInfo.tiaoji === '1',
        generatedAt: this.formatConfirmSheetTime(generatedAt),
        watermarkTimestamp: generatedAt.getTime(),
        fileTimestamp: this.formatConfirmSheetFileTimestamp(generatedAt),
        details: details
      }
    },
    getGaozhongConfirmDetails(selected, gArrs) {
      const details = []
      Object.keys(selected || {})
        .filter((key) => /^g\d{2}$/.test(key) && this.hasZhiyuanValue(selected[key]))
        .sort()
        .forEach((key) => {
          const batch = key.substring(1, 2)
          const schoolIndex = key.substring(2, 3)
          const schemeId = selected[key]
          details.push({
            batch: batch,
            schoolIndex: schoolIndex,
            schoolName: this.getGaozhongConfirmSchoolName(
              gArrs,
              batch,
              schemeId
            ),
            majors: []
          })
        })
      return details
    },
    getZhongzhiConfirmDetails(selected, zzName, zArrs) {
      const details = []
      Object.keys(zzName || {})
        .filter((key) => /^z\d{2}$/.test(key) && this.hasZhiyuanValue(zzName[key]))
        .sort()
        .forEach((schoolKey) => {
          const majors = Object.keys(selected || {})
            .filter((key) => {
              return (
                key.indexOf(schoolKey) === 0 &&
                key.length > schoolKey.length &&
                this.hasZhiyuanValue(selected[key])
              )
            })
            .sort()
            .map((key) => {
              const majorIndex = key.substring(3, 4)
              const schemeId = selected[key]
              return {
                majorIndex: majorIndex,
                majorName: this.getZhongzhiConfirmMajorName(zArrs, schemeId)
              }
            })
          details.push({
            batch: schoolKey.substring(1, 2),
            schoolIndex: schoolKey.substring(2, 3),
            schoolName: zzName[schoolKey],
            majors: majors
          })
        })
      return details
    },
    getGaozhongConfirmSchoolName(gArrs, batch, schemeId) {
      const list = gArrs[Number(batch) - 1] || []
      for (let i = 0; i < list.length; i++) {
        if (String(list[i].id) === String(schemeId)) {
          return list[i].school || schemeId
        }
      }
      return schemeId
    },
    getZhongzhiConfirmMajorName(zArrs, schemeId) {
      for (let i = 0; i < zArrs.length; i++) {
        const list = zArrs[i] || []
        for (let j = 0; j < list.length; j++) {
          if (String(list[j].id) === String(schemeId)) {
            return list[j].major || schemeId
          }
        }
      }
      return schemeId
    },
    buildConfirmSheetFileName(sheetData) {
      const student = sheetData.studentInfo || {}
      const name = student.name || '考生'
      const testNum = student.testNum || ''
      const timestamp = sheetData.fileTimestamp || this.formatConfirmSheetFileTimestamp(new Date())
      return (
        (name + '_' + testNum + '_玉树州高中阶段志愿确认单_' + timestamp + '.pdf')
          .replace(/[\\/:*?"<>|]/g, '_')
          .replace(/\s+/g, '')
      )
    },
    async downloadPdfFile(sheetData, fileName) {
      const canvas = this.renderConfirmSheetToCanvas(sheetData)
      const blob = this.createConfirmSheetPdfBlob(canvas)
      this.downloadBlob(blob, fileName)
    },
    renderConfirmSheetToCanvas(sheetData) {
      const width = 794
      const scale = 2
      const left = 36
      const contentWidth = width - left * 2
      const student = sheetData.studentInfo || {}
      const info = sheetData.info || {}
      const basicRows = [
        [
          { text: '姓名', header: true },
          { text: student.name || info.name },
          { text: '准考证号', header: true },
          { text: student.testNum || info.testNum }
        ],
        [
          { text: '身份证号', header: true },
          { text: this.maskConfirmIdCard(student.idCard || info.idCard) },
          { text: '总分', header: true },
          { text: student.zongfen || info.zongfen }
        ],
        [
          { text: '考生类型', header: true },
          { text: info.languageType },
          { text: '志愿类型', header: true },
          { text: sheetData.formLabel }
        ],
        [
          { text: '毕业学校', header: true },
          { text: student.school || info.school },
          { text: '服从调剂', header: true },
          { text: sheetData.tiaoji ? '是' : '否' }
        ]
      ]
      const detailRows = [
        [
          { text: '批次', header: true },
          { text: '志愿', header: true },
          { text: '学校', header: true },
          { text: '专业志愿', header: true }
        ]
      ].concat(
        sheetData.details.map((item) => {
          const majors =
            item.majors && item.majors.length
              ? item.majors
                  .map((major) => {
                    return '专业志愿' + major.majorIndex + ': ' + major.majorName
                  })
                  .join('\n')
              : '-'
          return [
            { text: '第' + item.batch + '批次' },
            { text: '第' + item.schoolIndex + '志愿' },
            { text: item.schoolName },
            { text: majors }
          ]
        })
      )
      const basicColumns = [110, 250, 110, contentWidth - 470]
      const detailColumns = [82, 82, 230, contentWidth - 394]
      const measureCanvas = document.createElement('canvas')
      const measureContext = measureCanvas.getContext('2d')
      const titleHeight = 34
      const timeHeight = 22
      const basicHeight = this.measureConfirmTableHeight(
        measureContext,
        basicRows,
        basicColumns
      )
      const detailHeight = this.measureConfirmTableHeight(
        measureContext,
        detailRows,
        detailColumns
      )
      const noteHeight = 24
      const signatureTopGap = 28
      const signatureHeight = 24
      const contentHeight =
        28 +
        titleHeight +
        timeHeight +
        18 +
        basicHeight +
        18 +
        detailHeight +
        18 +
        noteHeight +
        signatureTopGap +
        signatureHeight +
        24
      const pageContentWidth = 595.28 - 24 * 2
      const pageContentHeight = 841.89 - 24 * 2
      const minPageHeight = Math.ceil(
        (pageContentHeight * width) / pageContentWidth
      )
      const height = Math.ceil(contentHeight / minPageHeight) * minPageHeight
      const canvas = document.createElement('canvas')
      canvas.width = width * scale
      canvas.height = height * scale
      const context = canvas.getContext('2d')
      context.scale(scale, scale)
      context.fillStyle = '#fff'
      context.fillRect(0, 0, width, height)
      this.drawConfirmWatermark(context, width, contentHeight - 24, sheetData)
      context.fillStyle = '#111'
      context.textBaseline = 'top'
      let y = 28
      context.font = this.getConfirmCanvasFont(24, true)
      context.textAlign = 'center'
      context.fillText('玉树州高中阶段志愿确认单', width / 2, y)
      y += titleHeight
      context.font = this.getConfirmCanvasFont(13, false)
      context.fillText('生成时间：' + sheetData.generatedAt, width / 2, y)
      y += timeHeight + 18
      y = this.drawConfirmTable(context, basicRows, basicColumns, left, y)
      y += 18
      y = this.drawConfirmTable(context, detailRows, detailColumns, left, y)
      y += 18
      context.font = this.getConfirmCanvasFont(14, false)
      context.textAlign = 'left'
      context.fillStyle = '#111'
      context.fillText(
        '以上志愿信息来自系统正式提交数据，请认真核对。',
        left,
        y
      )
      y += noteHeight + signatureTopGap
      const signatureLabel = '学生签字：'
      const signatureLineWidth = 150
      context.font = this.getConfirmCanvasFont(14, false)
      context.textAlign = 'left'
      context.fillText(
        signatureLabel,
        width -
          left -
          signatureLineWidth -
          context.measureText(signatureLabel).width -
          8,
        y
      )
      context.beginPath()
      context.moveTo(width - left - signatureLineWidth, y + 18)
      context.lineTo(width - left, y + 18)
      context.strokeStyle = '#333'
      context.lineWidth = 1
      context.stroke()
      return canvas
    },
    drawConfirmWatermark(context, width, watermarkHeight, sheetData) {
      const student = sheetData.studentInfo || {}
      const info = sheetData.info || {}
      const titleText = '玉树州高中阶段志愿确认单'
      const detailText =
        '准考证号：' +
        (student.testNum || info.testNum || '-') +
        '    ' +
        (sheetData.watermarkTimestamp || '-')
      context.save()
      context.beginPath()
      context.rect(0, 0, width, watermarkHeight)
      context.clip()
      context.globalAlpha = 0.08
      context.fillStyle = '#333'
      context.textAlign = 'center'
      context.textBaseline = 'middle'
      context.rotate(-Math.PI / 6)
      let rowIndex = 0
      for (let y = -watermarkHeight; y < watermarkHeight * 2; y += 70) {
        const rowOffset = rowIndex % 2 === 0 ? 0 : 150
        for (let x = -width; x < width * 2; x += 300) {
          context.font = this.getConfirmCanvasFont(20, true)
          context.fillText(titleText, x + rowOffset, y)
          context.font = this.getConfirmCanvasFont(12, false)
          context.fillText(detailText, x + rowOffset, y + 21)
        }
        rowIndex += 1
      }
      context.restore()
    },
    maskConfirmIdCard(value) {
      const text = String(value === undefined || value === null ? '' : value)
      if (text.length < 14) {
        return text
      }
      return text.substring(0, 6) + '********' + text.substring(14)
    },
    measureConfirmTableHeight(context, rows, columns) {
      let height = 0
      context.font = this.getConfirmCanvasFont(14, false)
      rows.forEach((row) => {
        let rowHeight = 34
        row.forEach((cell, index) => {
          context.font = this.getConfirmCanvasFont(14, cell.header)
          const lines = this.wrapConfirmText(
            context,
            cell.text,
            columns[index] - 16
          )
          rowHeight = Math.max(rowHeight, lines.length * 20 + 14)
        })
        height += rowHeight
      })
      return height
    },
    drawConfirmTable(context, rows, columns, x, y) {
      rows.forEach((row) => {
        let rowHeight = 34
        const cellLines = row.map((cell, index) => {
          context.font = this.getConfirmCanvasFont(14, cell.header)
          const lines = this.wrapConfirmText(
            context,
            cell.text,
            columns[index] - 16
          )
          rowHeight = Math.max(rowHeight, lines.length * 20 + 14)
          return lines
        })
        let currentX = x
        row.forEach((cell, index) => {
          context.fillStyle = cell.header
            ? 'rgba(245, 245, 245, 0.78)'
            : 'rgba(255, 255, 255, 0)'
          context.fillRect(currentX, y, columns[index], rowHeight)
          context.strokeStyle = '#333'
          context.lineWidth = 1
          context.strokeRect(currentX, y, columns[index], rowHeight)
          context.fillStyle = '#111'
          context.font = this.getConfirmCanvasFont(14, cell.header)
          context.textAlign = 'center'
          const lines = cellLines[index]
          const textY = y + (rowHeight - lines.length * 20) / 2
          lines.forEach((line, lineIndex) => {
            context.fillText(
              line,
              currentX + columns[index] / 2,
              textY + lineIndex * 20
            )
          })
          currentX += columns[index]
        })
        y += rowHeight
      })
      return y
    },
    wrapConfirmText(context, value, maxWidth) {
      const text = String(value === undefined || value === null ? '' : value)
      const result = []
      text.split('\n').forEach((part) => {
        if (!part) {
          result.push('')
          return
        }
        let line = ''
        for (let i = 0; i < part.length; i++) {
          const nextLine = line + part.charAt(i)
          if (line && context.measureText(nextLine).width > maxWidth) {
            result.push(line)
            line = part.charAt(i)
          } else {
            line = nextLine
          }
        }
        result.push(line)
      })
      return result.length ? result : ['']
    },
    getConfirmCanvasFont(size, bold) {
      return (
        (bold ? '700 ' : '400 ') +
        size +
        'px Arial, "Microsoft YaHei", SimSun, sans-serif'
      )
    },
    formatConfirmSheetTime(date) {
      return (
        date.getFullYear() +
        '-' +
        this.padConfirmTime(date.getMonth() + 1) +
        '-' +
        this.padConfirmTime(date.getDate()) +
        ' ' +
        this.padConfirmTime(date.getHours()) +
        ':' +
        this.padConfirmTime(date.getMinutes()) +
        ':' +
        this.padConfirmTime(date.getSeconds())
      )
    },
    formatConfirmSheetFileTimestamp(date) {
      return (
        date.getFullYear() +
        this.padConfirmTime(date.getMonth() + 1) +
        this.padConfirmTime(date.getDate()) +
        this.padConfirmTime(date.getHours()) +
        this.padConfirmTime(date.getMinutes()) +
        this.padConfirmTime(date.getSeconds())
      )
    },
    padConfirmTime(value) {
      const text = String(value)
      return text.length < 2 ? '0' + text : text
    },
    createConfirmSheetPdfBlob(canvas) {
      const pageWidth = 595.28
      const pageHeight = 841.89
      const margin = 24
      const contentWidth = pageWidth - margin * 2
      const contentHeight = pageHeight - margin * 2
      const pointPerPixel = contentWidth / canvas.width
      const sliceHeight = Math.max(1, Math.ceil(contentHeight / pointPerPixel))
      const pages = []

      for (let y = 0; y < canvas.height; y += sliceHeight) {
        const currentHeight = Math.min(sliceHeight, canvas.height - y)
        const pageCanvas = document.createElement('canvas')
        pageCanvas.width = canvas.width
        pageCanvas.height = currentHeight
        const context = pageCanvas.getContext('2d')
        context.fillStyle = '#fff'
        context.fillRect(0, 0, pageCanvas.width, pageCanvas.height)
        context.drawImage(
          canvas,
          0,
          y,
          canvas.width,
          currentHeight,
          0,
          0,
          canvas.width,
          currentHeight
        )
        const dataUrl = pageCanvas.toDataURL('image/jpeg', 0.92)
        pages.push({
          width: pageCanvas.width,
          height: pageCanvas.height,
          pdfHeight: currentHeight * pointPerPixel,
          data: this.base64ToBytes(dataUrl.split(',')[1])
        })
      }

      return this.buildPdfBlob(pages, pageWidth, pageHeight, margin, contentWidth)
    },
    buildPdfBlob(pages, pageWidth, pageHeight, margin, contentWidth) {
      const chunks = []
      const offsets = [0]
      let byteLength = 0
      const addBytes = (bytes) => {
        chunks.push(bytes)
        byteLength += bytes.length
      }
      const addText = (text) => {
        addBytes(this.asciiToBytes(text))
      }
      const addObject = (id, writer) => {
        offsets[id] = byteLength
        addText(id + ' 0 obj\n')
        writer()
        addText('\nendobj\n')
      }
      const objectCount = 2 + pages.length * 3
      const pageRefs = pages
        .map((item, index) => {
          return 3 + index * 3 + ' 0 R'
        })
        .join(' ')

      addText('%PDF-1.4\n%\xFF\xFF\xFF\xFF\n')
      addObject(1, () => {
        addText('<< /Type /Catalog /Pages 2 0 R >>')
      })
      addObject(2, () => {
        addText('<< /Type /Pages /Kids [' + pageRefs + '] /Count ' + pages.length + ' >>')
      })

      pages.forEach((page, index) => {
        const pageObjectId = 3 + index * 3
        const contentObjectId = pageObjectId + 1
        const imageObjectId = pageObjectId + 2
        const imageName = 'Im' + (index + 1)
        const imageHeight = Math.min(page.pdfHeight, pageHeight - margin * 2)
        const imageY = pageHeight - margin - imageHeight
        const content =
          'q\n' +
          contentWidth.toFixed(2) +
          ' 0 0 ' +
          imageHeight.toFixed(2) +
          ' ' +
          margin.toFixed(2) +
          ' ' +
          imageY.toFixed(2) +
          ' cm\n/' +
          imageName +
          ' Do\nQ'

        addObject(pageObjectId, () => {
          addText(
            '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' +
              pageWidth.toFixed(2) +
              ' ' +
              pageHeight.toFixed(2) +
              '] /Resources << /XObject << /' +
              imageName +
              ' ' +
              imageObjectId +
              ' 0 R >> >> /Contents ' +
              contentObjectId +
              ' 0 R >>'
          )
        })
        addObject(contentObjectId, () => {
          addText(
            '<< /Length ' +
              this.asciiToBytes(content).length +
              ' >>\nstream\n' +
              content +
              '\nendstream'
          )
        })
        addObject(imageObjectId, () => {
          addText(
            '<< /Type /XObject /Subtype /Image /Width ' +
              page.width +
              ' /Height ' +
              page.height +
              ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' +
              page.data.length +
              ' >>\nstream\n'
          )
          addBytes(page.data)
          addText('\nendstream')
        })
      })

      const xrefStart = byteLength
      addText('xref\n0 ' + (objectCount + 1) + '\n0000000000 65535 f \n')
      for (let i = 1; i <= objectCount; i++) {
        addText(this.padPdfOffset(offsets[i]) + ' 00000 n \n')
      }
      addText(
        'trailer\n<< /Size ' +
          (objectCount + 1) +
          ' /Root 1 0 R >>\nstartxref\n' +
          xrefStart +
          '\n%%EOF'
      )
      return new Blob(chunks, {
        type: 'application/pdf'
      })
    },
    downloadBlob(blob, fileName) {
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    asciiToBytes(text) {
      const bytes = new Uint8Array(text.length)
      for (let i = 0; i < text.length; i++) {
        bytes[i] = text.charCodeAt(i) & 0xff
      }
      return bytes
    },
    base64ToBytes(base64) {
      const binary = window.atob(base64)
      const bytes = new Uint8Array(binary.length)
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i)
      }
      return bytes
    },
    padPdfOffset(offset) {
      const value = String(offset)
      return '0000000000'.substring(0, 10 - value.length) + value
    },
    escapeHtml(value) {
      return String(value === undefined || value === null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    hasZhiyuanValue(value) {
      return value !== undefined && value !== null && String(value).trim() !== ''
    },
    isZhiyuanSwitchOpen() {
      return this.zhiyuanFlag === true || this.zhiyuanFlag === 'true'
    },
    isZhiyuanSubmitted() {
      return String(this.zhiyuanSubmit) === '1'
    },
    syncZhiyuanEditableStatus() {
      this.disabledFlag =
        this.isZhiyuanSubmitted() ||
        (!this.isZhiyuanSwitchOpen() && !this.hasSavedDraft)
    },
    canOperateZhiyuan() {
      if (this.isZhiyuanSubmitted()) {
        this.$message.error('志愿已正式提交，不能自行修改')
        return false
      }
      if (!this.isZhiyuanSwitchOpen() && !this.hasSavedDraft) {
        this.$message.error('志愿填报暂未开放，不能保存草稿或正式提交志愿')
        return false
      }
      return true
    },
    getZhiyuanStatusText() {
      if (!this.studentInfoLoaded) {
        return ''
      }
      if (this.isZhiyuanSubmitted()) {
        return '志愿已正式提交，不能自行修改。如需修改，请联系管理员重填志愿。'
      }
      if (this.hasSavedDraft) {
        return '当前已有草稿，可继续修改或正式提交志愿。'
      }
      if (!this.isZhiyuanSwitchOpen()) {
        return '志愿填报暂未开放，不能保存草稿或正式提交志愿。'
      }
      return ''
    },
    hasSelectedZhiyuan(value) {
      if (value === undefined || value === null) {
        return false
      }
      if (typeof value === 'object') {
        return Object.keys(value).some((key) => {
          return this.hasSelectedZhiyuan(value[key])
        })
      }
      return this.hasZhiyuanValue(value)
    },
    zzSchoolChange(batch, schoolCount, e) {
      const schoolKey = 'z' + batch + schoolCount
      const schoolValue = e && e.target ? e.target.value : ''
      if (
        this.hasZhiyuanValue(schoolValue) &&
        !this.arePreviousZhongzhiSchoolsFilled(batch, schoolCount)
      ) {
        this.$set(this.zzSchoolNameForm, schoolKey, '')
        this.clearFollowingZhongzhiMajors(batch, schoolCount, 0)
        this.$set(this.zOptionArrs, schoolKey, [])
        this.clearFollowingZhongzhiSchools(batch, schoolCount)
        this.$message.error(
          '请先按顺序填写第' + batch + '批次前序学校志愿'
        )
        return
      }
      if (
        this.hasZhiyuanValue(schoolValue) &&
        this.hasDuplicateZhongzhiSchool(batch, schoolCount, schoolValue)
      ) {
        this.$set(this.zzSchoolNameForm, schoolKey, '')
        this.clearFollowingZhongzhiMajors(batch, schoolCount, 0)
        this.$set(this.zOptionArrs, schoolKey, [])
        this.clearFollowingZhongzhiSchools(batch, schoolCount)
        this.$message.error('第' + batch + '批次中职学校志愿不能重复')
        return
      }
      this.clearFollowingZhongzhiMajors(batch, schoolCount, 0)
      this.zzSchoolChangeCopy(batch, schoolCount, schoolValue)
      if (
        !this.hasZhiyuanValue(schoolValue) &&
        this.clearFollowingZhongzhiSchools(batch, schoolCount)
      ) {
        this.$message.warning('已清空本批次后续学校志愿，请按顺序填写')
      }
    },
    clearFollowingZhongzhiSchools(batch, schoolCount) {
      let cleared = false
      for (let i = schoolCount + 1; i <= this.zhongzhiSchoolCount; i++) {
        const schoolKey = 'z' + batch + i
        if (this.hasZhiyuanValue(this.zzSchoolNameForm[schoolKey])) {
          cleared = true
        }
        this.$set(this.zzSchoolNameForm, schoolKey, '')
        if (this.clearFollowingZhongzhiMajors(batch, i, 0)) {
          cleared = true
        }
        this.$set(this.zOptionArrs, schoolKey, [])
      }
      return cleared
    },

    zzSchoolChangeCopy(batch, schoolCount, schoolValue) {
      let tempZhiyuan = this.zArrs[batch - 1] || []
      //从这些志愿中选择school相同的出来
      let tempArr = []
      tempZhiyuan.forEach((ele) => {
        if (ele.school === schoolValue) {
          tempArr.push(ele)
        }
      })
      this.$set(this.zOptionArrs, 'z' + batch + schoolCount, tempArr)
    },
    backMain() {
      this.$router.push('/main')
    },

    getDate() {
      const nowDate = new Date()
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
        hours: nowDate.getHours(),
        minutes: nowDate.getMinutes(),
        seconds: nowDate.getSeconds()
      }

      const newmonth = date.month > 10 ? date.month : '0' + date.month
      const newday = date.date > 10 ? date.date : '0' + date.date
      const newminutes = date.minutes > 10 ? date.minutes : '0' + date.minutes
      const newseconds = date.seconds > 10 ? date.seconds : '0' + date.seconds
      let result =
        date.year +
        '-' +
        newmonth +
        '-' +
        newday +
        ' ' +
        date.hours +
        ':' +
        newminutes +
        ':' +
        newseconds
      return result
    }
  }
}
</script>
<style scoped>
table td {
  text-align: center;
}

table {
  border-collapse: collapse;
  white-space: nowrap;
  overflow-x: auto; /* 启用横向滚动条 */
}

.gaozhong-volunteer-table th,
.zhongzhi-volunteer-table th {
  background: #f5f7fa;
  color: #303133;
  font-weight: 600;
  padding: 8px 12px;
}

.gaozhong-volunteer-table .volunteer-table-header th,
.zhongzhi-volunteer-table .volunteer-table-header th {
  border-bottom: 2px solid #aeb8c4;
  border-top: 2px solid #aeb8c4;
}

.gaozhong-volunteer-table .volunteer-table-header th:first-child,
.zhongzhi-volunteer-table .volunteer-table-header th:first-child {
  border-left: 2px solid #aeb8c4;
}

.gaozhong-volunteer-table .volunteer-table-header th:last-child,
.zhongzhi-volunteer-table .volunteer-table-header th:last-child {
  border-right: 2px solid #aeb8c4;
}

.gaozhong-volunteer-table td,
.zhongzhi-volunteer-table td {
  border-color: #e4e7ed;
  padding: 5px 10px;
  vertical-align: middle;
}

.gaozhong-volunteer-table .gaozhong-volunteer-group-alt td {
  background: #fafafa;
}

.gaozhong-volunteer-table .gaozhong-volunteer-group-start td {
  border-top-color: #dcdfe6;
}

.gaozhong-volunteer-table .gaozhong-batch-frame-start td,
.zhongzhi-volunteer-table .zhongzhi-batch-frame-start td {
  border-top: 2px solid #aeb8c4;
}

.gaozhong-volunteer-table .gaozhong-batch-frame-end td,
.zhongzhi-volunteer-table .zhongzhi-batch-frame-end td {
  border-bottom: 2px solid #aeb8c4;
}

.gaozhong-volunteer-table .gaozhong-batch-cell,
.zhongzhi-volunteer-table .zhongzhi-batch-cell {
  border-bottom: 2px solid #aeb8c4;
  border-left: 2px solid #aeb8c4;
}

.gaozhong-volunteer-table .gaozhong-school-cell,
.zhongzhi-volunteer-table .zhongzhi-major-select-cell {
  border-right: 2px solid #aeb8c4;
}

.zhongzhi-volunteer-table .zhongzhi-batch-last-school-cell {
  border-bottom: 2px solid #aeb8c4;
}

.zhongzhi-volunteer-table .zhongzhi-major-label,
.zhongzhi-volunteer-table .zhongzhi-major-select-cell {
  text-align: left;
}

.zhongzhi-volunteer-table .zhongzhi-major-label {
  color: #606266;
  font-weight: 500;
}

.zhongzhi-volunteer-table .zhongzhi-volunteer-group-alt td {
  background: #fafafa;
}

.zhongzhi-volunteer-table .zhongzhi-volunteer-group-start td {
  border-top-color: #dcdfe6;
}

.printHide {
  display: none;
}

.zhiyuan-status-tip {
  margin-top: 12px;
  color: #f56c6c;
  font-size: 14px;
}

@media print {
  @page {
    size: auto;
    margin: 0mm;
  }
  .noprint {
    display: none;
  }
  .printHide {
    display: block;
  }
}
</style>
<style>
.zhiyuan-confirm-box {
  width: 800px;
  max-width: calc(100vw - 32px);
}

.zhiyuan-confirm-box .el-message-box__message {
  max-height: 64vh;
  overflow: auto;
}

.zhiyuan-confirm-box .el-message-box__content {
  padding-bottom: 8px;
}

.zhiyuan-confirm-box .el-message-box__title {
  display: block;
  text-align: center;
}

.zhiyuan-confirm-box .el-message-box__btns {
  border-top: 1px solid #ebeef5;
  padding-top: 12px;
}

.zy-confirm-content {
  text-align: left;
  line-height: 1.6;
  color: #303133;
  word-break: break-word;
}

.zy-confirm-intro {
  margin-bottom: 12px;
  color: #606266;
}

.zy-summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 14px;
}

.zy-summary-card {
  border: 1px solid #ebeef5;
  background: #f8fafc;
  border-radius: 6px;
  padding: 8px 10px;
}

.zy-summary-card span {
  display: block;
  color: #909399;
  font-size: 12px;
  margin-bottom: 4px;
}

.zy-summary-card strong {
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}

.zy-detail-title {
  font-weight: 600;
  margin: 4px 0 8px;
}

.zy-detail-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  margin-bottom: 12px;
}

.zy-detail-table th,
.zy-detail-table td {
  border: 1px solid #dcdfe6;
  padding: 7px 8px;
  text-align: left;
  vertical-align: top;
  white-space: normal;
}

.zy-detail-table th {
  background: #f5f7fa;
  color: #303133;
  font-weight: 600;
}

.zy-detail-table th:nth-child(1),
.zy-detail-table th:nth-child(2),
.zy-detail-table td:nth-child(1),
.zy-detail-table td:nth-child(2) {
  width: 72px;
}

.zy-empty-detail {
  border: 1px dashed #f56c6c;
  background: #fef0f0;
  color: #f56c6c;
  padding: 8px 10px;
  border-radius: 4px;
  margin-bottom: 12px;
}

.zy-confirm-alert {
  border-radius: 4px;
  padding: 9px 11px;
  margin-top: 10px;
}

.zy-confirm-alert.warning {
  border: 1px solid #faecd8;
  background: #fdf6ec;
  color: #b88230;
}

.zy-confirm-alert.danger {
  border: 1px solid #fde2e2;
  background: #fef0f0;
  color: #f56c6c;
}

@media (max-width: 640px) {
  .zy-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
